import React from "react";
import styled from "styled-components";
import { DomeText } from "./typography";
import { Colors } from "./styles/Colors";

const Wrapper = styled.div`
  display: ${(props) => (props.centered ? "flex" : "inline-flex")};
  flex-direction: column;
  align-items: center;

  svg {
    margin: 0 auto 16px;
  }

  span {
    color: ${(props) => (props.light ? Colors.lightBlue : Colors.grey)};
  }
`;

export default function DomeHeader({ centered, light, text }) {
  return (
    <Wrapper centered={centered} light={light}>
      <svg
        width="28"
        height="14"
        viewBox="0 0 28 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M28 14C28 6.26801 21.732 2.59151e-07 14 1.66948e-07C6.26801 7.47453e-08 9.2203e-08 6.26801 0 14L28 14Z"
          fill="#FFC000"
        />
      </svg>
      <DomeText>{text}</DomeText>
    </Wrapper>
  );
}
